import React, { FC } from "react";
import { Translate } from "../../components/translations";
import Section from "../../components/section";
import { PageHero } from "../../components/page-hero";
import Layout from "../../components/layout/layout";

const GDPR: FC = () => (
  <div className="content-wrapper">
    <Layout>
      <PageHero title="HEXOMATE_GDPR_TITLE" titleSmall/>
      <Section>
        <div className="col-lg-12">
          <Translate name="HEXOMATE_GDPR_CONTENT" />
        </div>
      </Section>
    </Layout>
  </div>
);

export default GDPR;
